export enum TypeOfQuestionarie {
    BYUNITY = 1,
    BYUSER = 2,
}